export default {
  SEARCH_ALLIANZ_CUSTOMER_AVAILABLE_BALANCE_QUERY: Symbol.for('SEARCH_ALLIANZ_CUSTOMER_AVAILABLE_BALANCE_QUERY'),
  ALLIANZ_CUSTOMER_AVAILABLE_BALANCE_REPOSITORY: Symbol.for('ALLIANZ_CUSTOMER_AVAILABLE_BALANCE_REPOSITORY'),
};
